import { jsPDF as JsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'
import { footerLinks } from '@constants/book-request'

// Field order + labels mirror the Connect viewConfig (book-request-ac-snippet).
// Values that come empty/null mean the field wasn't filled, so they're skipped.
const FIELDS = [
  { key: 'person_type', label: 'Identificación' },
  { key: 'natural_person_full_name', label: 'Nombre y Apellido' },
  { key: 'legal_person_company_name', label: 'Razón Social' },
  { key: 'legal_person_representative_name', label: 'Representante Legal' },
  { key: 'identification_type', label: 'Doc. Identidad' },
  { key: 'identification_number', label: 'Número de documento' },
  { key: 'domicile', label: 'Domicilio' },
  { key: 'phone', label: 'Teléfono' },
  { key: 'email', label: 'Email' },
  { key: 'is_adult', label: '¿Mayor de edad?' },
  { key: 'tutor_full_name', label: 'Nombre y Apellido del apoderado' },
  { key: 'tutor_identification_number', label: 'Documento del apoderado' },
  { key: 'tutor_email', label: 'Email del apoderado' },
  { key: 'tutor_phone', label: 'Teléfono del apoderado' },
  { key: 'tutor_address', label: 'Dirección del apoderado' },
  { key: 'request_type', label: 'Tipo de solicitud' },
  { key: 'type_good', label: 'Tipo de bien' },
  { key: 'request_type_level_1', label: 'Tipo de consulta' },
  { key: 'request_type_level_2', label: 'Motivo de la solicitud' },
  { key: 'amount', label: 'Monto reclamado' },
  { key: 'store_name', label: 'Nombre de la tienda o restaurante' },
  { key: 'request_details', label: 'Detalle de la reclamación o queja' },
  { key: 'date', label: 'Fecha del pedido o consulta' },
]

const COLORS = {
  orange: [255, 94, 54],
  dark: [47, 45, 43],
  heading: [47, 47, 47],
  text: [58, 58, 58],
  label: [70, 70, 70], // table key — dark enough to read comfortably
  zebra: [250, 250, 250],
  separator: [235, 235, 235],
  footerText: [207, 207, 207],
  indecopi: [78, 78, 78],
  white: [255, 255, 255],
}

const MARGIN_X = 40
const HEADER_H = 74
const FOOTER_H = 100

// Font sizes in pt (the PDF unit), tuned for comfortable on-screen/print reading.
const SIZE = {
  title: 16,
  body: 12,
  table: 12,
  footerTitle: 12,
  help: 10.5,
}

const INDECOPI_TEXT =
  'La formulación del reclamo no impide acudir a otras vías de solución de controversias ni es requisito previo para interponer una denuncia ante el INDECOPI. El proveedor ' +
  'debe dar respuesta al reclamo o queja en un plazo no mayor a siete (7) días hábiles, el cual es improrrogable.'

const HELP_TEXT =
  'Si tienes alguna duda o queja, estamos para ayudarte. Contáctanos a través de nuestro Centro de ayuda.'

const ICONS = {
  facebook:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#ffffff"><path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.13 8.44 9.88v-6.99H7.9v-2.89h2.5' +
    '4V9.85c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.44 2.89h-2.34V22c4.78-.75 8.44-4.88 8.44-9.94z"/></svg>',
  x:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#ffffff"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.83' +
    '5L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
  instagram:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#ffffff"><path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 ' +
    '1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-' +
    '1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58' +
    '.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41 1.27-.06 1.65-.07 4.85-.07M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 ' +
    '4.14.63c-.79.31-1.46.72-2.12 1.38C1.36 2.67.95 3.34.63 4.14.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.31.79.72 1.46 1.38 2.12.66' +
    '.66 1.33 1.07 2.12 1.38.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56.79-.31 1.46-.72 2.12-1.38.66-.66 1.07-1.33 1.38-2.12.3-.7' +
    '6.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91-.31-.79-.72-1.46-1.38-2.12-.66-.66-1.33-1.07-2.12-1.38-.76-.3-1.64-.5-2.91-.56C15.6' +
    '7.01 15.26 0 12 0zm0 5.84A6.16 6.16 0 1018.16 12 6.16 6.16 0 0012 5.84zM12 16a4 4 0 110-8 4 4 0 010 8zm6.41-10.85a1.44 1.44 0 100 2.88 1.44 1.44 0 000-2.88z"/></svg>',
}

function clean(value) {
  if (value === null || value === undefined) {
    return ''
  }
  const text = String(value).trim()
  return text === '' || text.toLowerCase() === 'null' ? '' : text
}

function formatDateTime(iso) {
  const date = new Date(iso)
  if (isNaN(date.getTime())) {
    return ''
  }
  const pad = n => String(n).padStart(2, '0')
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

function loadImage(src) {
  return new Promise(resolve => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = () => resolve(null)
    img.src = src
  })
}

function blobToDataUrl(blob) {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = () => resolve('')
    reader.readAsDataURL(blob)
  })
}

// PNG from public/ → data URL + intrinsic size (for aspect-correct placement).
async function loadPng(url) {
  const dataUrl = await fetch(url)
    .then(res => res.blob())
    .then(blobToDataUrl)
    .catch(() => '')
  if (!dataUrl) {
    return null
  }
  const img = await loadImage(dataUrl)
  return img ? { dataUrl, width: img.naturalWidth, height: img.naturalHeight } : null
}

// jsPDF can't embed SVG; rasterize each icon to a PNG data URL.
function svgToPng(svg, size) {
  return new Promise(resolve => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = size
      canvas.height = size
      canvas.getContext('2d').drawImage(img, 0, 0, size, size)
      resolve(canvas.toDataURL('image/png'))
    }
    img.onerror = () => resolve('')
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)
  })
}

function bufferToBase64(buffer) {
  let binary = ''
  const bytes = new Uint8Array(buffer)
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000))
  }
  return btoa(binary)
}

// TTF from public/ as base64 for jsPDF's VFS (empty string on failure → fallback).
function loadFont(url) {
  return fetch(url)
    .then(res => res.arrayBuffer())
    .then(bufferToBase64)
    .catch(() => '')
}

function drawWrapped(doc, text, x, y, maxWidth, lineHeight) {
  const lines = doc.splitTextToSize(text, maxWidth)
  doc.text(lines, x, y)
  return y + lines.length * lineHeight
}

// Logo, social icons and Roboto fonts are identical across downloads — load once.
let assetsPromise
function loadAssets() {
  if (assetsPromise) {
    return assetsPromise
  }
  const base = process.env.BASE_URL || '/'
  assetsPromise = Promise.all([
    loadPng(`${base}rappilogowhite.png`),
    Promise.all(Object.values(ICONS).map(svg => svgToPng(svg, 48))),
    loadFont(`${base}fonts/Roboto-Regular.ttf`),
    loadFont(`${base}fonts/Roboto-Bold.ttf`),
  ]).then(([logo, iconPngs, robotoRegular, robotoBold]) => {
    const icons = {}
    Object.keys(ICONS).forEach((key, i) => {
      icons[key] = iconPngs[i]
    })
    return { logo, icons, robotoRegular, robotoBold }
  })
  return assetsPromise
}

export async function downloadBookRequestPdf(submission, countryCode) {
  const attrs = (submission && submission.payload && submission.payload.Attributes) || {}
  const name =
    clean(attrs.natural_person_full_name) ||
    clean(attrs.legal_person_company_name) ||
    'usuario'
  const contactId = clean(
    submission &&
      (submission.contactId || (submission.response && submission.response.ContactId))
  )
  const dateTime = formatDateTime(submission && submission.submittedAt)
  const links = footerLinks(countryCode)
  const { logo, icons, robotoRegular, robotoBold } = await loadAssets()

  const doc = new JsPDF({ unit: 'pt', format: 'a4' })
  let FONT = 'helvetica'
  if (robotoRegular && robotoBold) {
    doc.addFileToVFS('Roboto-Regular.ttf', robotoRegular)
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal')
    doc.addFileToVFS('Roboto-Bold.ttf', robotoBold)
    doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold')
    FONT = 'Roboto'
  }
  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()
  const contentWidth = pageWidth - MARGIN_X * 2

  // Header + footer banners are redrawn on every page autoTable lays out.
  const drawHeader = () => {
    doc.setFillColor(...COLORS.orange)
    doc.rect(0, 0, pageWidth, HEADER_H, 'F')
    if (logo) {
      const h = 28
      const w = h * (logo.width / logo.height)
      doc.addImage(logo.dataUrl, 'PNG', (pageWidth - w) / 2, (HEADER_H - h) / 2, w, h)
    }
  }
  const drawFooter = () => {
    const top = pageHeight - FOOTER_H
    doc.setFillColor(...COLORS.dark)
    doc.rect(0, top, pageWidth, FOOTER_H, 'F')
    doc.setFont(FONT, 'bold')
    doc.setFontSize(SIZE.footerTitle)
    doc.setTextColor(...COLORS.white)
    doc.text('Equipo Rappi', MARGIN_X, top + 24)
    doc.setFont(FONT, 'normal')
    doc.setFontSize(SIZE.help)
    doc.setTextColor(...COLORS.footerText)
    const afterHelp = drawWrapped(doc, HELP_TEXT, MARGIN_X, top + 40, contentWidth, 13)
    const iconSize = 16
    const iconY = afterHelp + 6
    Object.keys(icons).forEach((key, i) => {
      if (!icons[key]) {
        return
      }
      const ix = MARGIN_X + i * (iconSize + 12)
      doc.addImage(icons[key], 'PNG', ix, iconY, iconSize, iconSize)
      if (links[key]) {
        doc.link(ix, iconY, iconSize, iconSize, { url: links[key] })
      }
    })
  }

  // Decorate each page once, even when several autoTables lay out on the same page.
  const decorated = new Set()
  const decoratePage = () => {
    const page = doc.internal.getNumberOfPages()
    if (decorated.has(page)) {
      return
    }
    decorated.add(page)
    drawHeader()
    drawFooter()
  }
  const tableMargin = { top: HEADER_H + 14, bottom: FOOTER_H + 14, left: MARGIN_X, right: MARGIN_X }
  const tableBase = { margin: tableMargin, theme: 'plain', didDrawPage: decoratePage }

  // Intro (page 1 only — letter content, not repeated across pages).
  let y = HEADER_H + 28
  doc.setFont(FONT, 'bold')
  doc.setFontSize(SIZE.title)
  doc.setTextColor(...COLORS.heading)
  doc.text('Libro de reclamaciones', MARGIN_X, y)
  y += 17
  doc.setFontSize(SIZE.body)
  y = drawWrapped(doc, `Identificación de contacto: ${contactId}`, MARGIN_X, y, contentWidth, 16)
  y += 9
  doc.setFont(FONT, 'normal')
  doc.setTextColor(...COLORS.text)
  y = drawWrapped(doc, `Estimado ${name}:`, MARGIN_X, y, contentWidth, 16)
  y = drawWrapped(doc, 'Su reclamo fue recibido por nuestra empresa a través del Libro de Reclamaciones.', MARGIN_X, y, contentWidth, 16)
  y = drawWrapped(doc, `Fecha y hora de presentación: ${dateTime}`, MARGIN_X, y, contentWidth, 16)

  // Key-value table — flows across pages, header/footer repeat via didDrawPage.
  const rows = FIELDS.map(f => [f.label, clean(attrs[f.key])]).filter(r => r[1] !== '')
  autoTable(doc, {
    ...tableBase,
    startY: y + 8,
    styles: {
      font: FONT,
      fontSize: SIZE.table,
      cellPadding: { top: 8, bottom: 8, left: 12, right: 12 },
      textColor: COLORS.text,
      lineWidth: { top: 0, right: 0, bottom: 0.5, left: 0 },
      lineColor: COLORS.separator,
      valign: 'middle',
    },
    bodyStyles: { fillColor: COLORS.white },
    alternateRowStyles: { fillColor: COLORS.zebra },
    columnStyles: {
      0: { cellWidth: contentWidth * 0.42, textColor: COLORS.label },
      1: { fontStyle: 'bold', textColor: COLORS.text },
    },
    body: rows,
  })

  // Closing (Equipo Rappi + INDECOPI) — also flows with repeating header/footer.
  autoTable(doc, {
    ...tableBase,
    startY: doc.lastAutoTable.finalY + 16,
    pageBreak: 'avoid',
    styles: { font: FONT, fontSize: SIZE.body, cellPadding: 0, lineWidth: 0, textColor: COLORS.text },
    body: [
      [{ content: 'Equipo Rappi', styles: { cellPadding: { bottom: 10 } } }],
      [{ content: INDECOPI_TEXT, styles: { textColor: COLORS.indecopi } }],
    ],
  })

  doc.save('Rappi-libro-de-reclamaciones.pdf')
}
